var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"bg-white",class:[
    _vm.stickToEdgesOnMobile ? 'sm:rounded-lg' : 'rounded-lg',
    _vm.flat ? 'border border-gray-200' : 'shadow ring-1 ring-black ring-opacity-5',
  ]},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }